<div class="option-result-wrapper" [class.success]="success">
  @if (success) {
    <div
      class="check-wrap"
      [class.success]="success"
      id="checkWrap"
      aria-live="polite"
      aria-atomic="true"
    >
      <div class="pulse"></div>
      <svg
        viewBox="0 0 100 100"
        role="img"
        aria-label="Check OK"
        xmlns="http://www.w3.org/1000/svg"
      >
        <!-- círculo de fondo -->
        <circle class="circle-bg" cx="50" cy="50" r="40"></circle>
        <!-- círculo animado (trazo verde que se dibuja) -->
        <circle class="circle-anim" cx="50" cy="50" r="40"></circle>
        <!-- check (path) -->
        <path class="check" d="M34 52 L46 64 L70 38" />
      </svg>
    </div>
    <p class="text">{{ 'general.correctValidationCanUpload' | translate }}</p>
  }
</div>
